import {Component, OnInit, Input, Output, EventEmitter} from '@angular/core';
import {BsModalRef} from 'ngx-bootstrap';

import {ApiService} from '../../../../../../projects/accounting/src/public_api';


@Component({
    selector: 'app-pending-detail',
    templateUrl: './pending-detail.component.html',
    styleUrls: ['./pending-detail.component.scss']
})
export class PendingDetailComponent implements OnInit {
    @Input() data = null;
    @Output() send = new EventEmitter();
    loading = false;
    canDelete = false;
    constructor(
        public bsModal: BsModalRef,
        private api: ApiService
    ){
    }

    ngOnInit() {
        console.log(this.data);
        if (this.data != null && this.data.Warehouse.ID === 168){
            this.canDelete = true;
        }
    }
    hide(){
        this.bsModal.hide()
    }
    confirm(){
        this.loading = true;
        this.api.pendingIEs({Mode: 'update', ID: this.data.ID}).subscribe(rs => {
            this.loading = false;
            this.send.emit(true);
            this.hide();
        })

    }
    delete(){
        this.loading = true;
        let body = {
            Action: this.data.Type,
            Confirmable: false,
            Details: [],
            ID: this.data.ID,
            InventoryID: this.data.Warehouse.ID,
            PaidAmount: 0,
            PartnerID: this.data.Partner.ID,
            PartnerType: "voc"
        };
        this.api.pomWarehousesTransfer(body).subscribe( rs => {
            this.loading = false;
            this.send.emit(true);
            this.hide();
        })
    }
}
